<template>
  <div class="main-body">
    <div class="header">删除订单</div>
    <div class="out">

      <div class="search2">

        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "删除订单列表.xls"
            style="display: inline-block;margin-left: 0px;">
          <el-button plain type="success" size="mini">导出</el-button>
        </download-excel>

        <div style="float: right">

          <el-select size="mini" v-model="businessCode" placeholder="请选择商家" style="margin-right:10px">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.businessName"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-date-picker style="margin-right: 10px;width:210px;" title="起止时间" size="mini"
                          v-model="startEndTime"
                          type="datetimerange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table" border>

        <el-table-column prop="serialNumber" label="订单流水号" width="130" fixed></el-table-column>
        <el-table-column prop="businessName" label="商家" width="105"></el-table-column>

        <el-table-column prop="userName" label="老人姓名" width="85"></el-table-column>

        <el-table-column prop="" label="服务项目" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsName}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" label="单价" width="105">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsPrice}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="105" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.number}}</div>
            </div>
          </template>
        </el-table-column>



        <el-table-column prop="price" label="总价" width="105"></el-table-column>


        <el-table-column width="105" label="订单来源" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderFrom =='business'">商家预工单</div>
            <div v-if="scope.row.orderFrom =='android' ">长者端</div>
            <div v-if="scope.row.orderFrom =='table' ">收银机</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="订单类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderType ==2 ">单独服务</div>
            <div v-if="scope.row.orderType ==3 ">合并服务</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="付款类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.payType == 'wx' ">微信</div>
            <div v-if="scope.row.payType == 'ali' ">支付宝</div>
            <div v-if="scope.row.payType == 'yue' ">余额</div>
            <div v-if="scope.row.payType == 'cash' ">现金</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status =='10' ">待付款</div>
            <div v-if="scope.row.status =='11' ">待接单</div>
            <div v-if="scope.row.status =='12' ">待开始</div>
            <div v-if="scope.row.status =='13' ">待结束</div>
            <div v-if="scope.row.status =='14' ">待评价</div>
            <div v-if="scope.row.status =='15' ">已取消</div>
            <div v-if="scope.row.status =='16' ">已评价</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" width="105" label="删除">
          <template slot-scope="scope">
            <span v-if="scope.row.isDelete == 1">已删除</span>
          </template>
        </el-table-column>

<!--        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="下单时间"></el-table-column>-->
<!--        <el-table-column prop="payTime" :formatter="timefilter" width="200" label="付款时间"></el-table-column>-->
        <el-table-column prop="planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>
        <el-table-column prop="completeTime" :formatter="timefilter" width="200" label="完成时间"></el-table-column>


        <el-table-column fixed="right" label="操作" width="120" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showInfo(scope.row)">详情</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="showModalInfo=false"></Info>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>



  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Info from "./Info";

export default {
  name: "Page",
  data() {
    return {

      showModal:false,
      showModalInfo:false,

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,


      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,

      arr_business:[],
      businessCode:'',


      startEndTime:[],

      json_fields: {

        "流水号": {
          field:"serialNumber",
          callback:value=>{
            return value+"-";
          }
        },
        "老人姓名": "userName",
        "商品名称": {
          filed:"listOrderGoodsDTO",
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].goodsName+'</div>';
            }
            return str;
          }
        },
        "单价": {
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].goodsPrice+'</div>';
            }
            return str;
          }
        },
        "数量": {
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].number+'</div>';
            }
            return str;
          }
        },
        "总价": "price",
        "商家": "businessName",

        "订单类型": {
          field:"orderType",
          callback:value=>{
            let title = "";
            if(value == 2){
              title = "单独服务";
            }
            if(value == 3){
              title = "合并服务";
            }
            return title;
          }
        },
        "付款类型": {
          field:"payType",
          callback:value=>{
            let title = "";
            if(value == 'cash'){
              title = "现金";
            }
            if(value == 'yue'){
              title = "余额";
            }
            if(value == 'wx'){
              title = "微信";
            }
            if(value == 'ali'){
              title = "支付宝";
            }
            return title;
          }
        },
        "订单状态": {
          field:"status",
          callback:value=>{
            let title = "";
            if(value == '10'){
              title = "待付款";
            }
            if(value == '11'){
              title = "待接单";
            }
            if(value == '12'){
              title = "待开始";
            }
            if(value == '13'){
              title = "待结束";
            }
            if(value == '14'){
              title = "待评价";
            }
            if(value == '15'){
              title = "已取消";
            }
            if(value == '16'){
              title = "已评价";
            }
            if(value == '17'){
              title = "已关闭";
            }
            return title;
          }
        },
        "删除": {
          field:"isDelete",
          callback:value=>{
            let title = "";
            if(value == 0){
              title = "";
            }
            if(value == 1){
              title = "已删除";
            }
            return title;
          }
        },
        "下单时间": {
          field:"createTime",
          callback:value=>{
            return timefilters(value);
          }
        },

      },

    }
  },
  components: {
    Info
  },
  created() {
    this.init();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {

      const now = new Date();
      const start = new Date(now - 1000 * 60 * 60 * 24 * 30);
      const end = new Date(now);
      this.startEndTime = [timefilters(start).substring(0,10), timefilters(end).substring(0,10)];



      this.getBusiness();
    },


    showInfo(row){
      this.showModalInfo = !this.showModalInfo;
      this.$refs.myInfo.init(row.orderBusinessCode);
    },

    getBusiness(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error === 0) {

          this.arr_business = [];
          let arr = response.data.data;
          for(let i=0;i<arr.length;i++){
            if(arr[i].businessType != 2){
              this.arr_business.push(arr[i]);
            }
          }

          //this.arr_business = response.data.data;
          if(this.arr_business.length>0){
            this.businessCode = this.arr_business[0].businessCode;
            this.getList();
          }

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },


    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this
      this.loading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:this.currentPage,
        pageSize:this.pageSize,

        businessCode:this.businessCode,
        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],

      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusinessGov/PageDelete",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },



    async fetchData(){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:1,
        pageSize:99999,
        businessCode:this.businessCode,
        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],
      }

      const response = await this.$axios.post(this.$shopUrl + "OrderBusinessGov/PageDelete",data);

      let list = response.data.data.pageInfo.list;
      if(list.length == 0){
        this.$message.info("暂无数据");
        this.showModal = false;
      }

      return list;
    },
    startDownload:function (){
      this.showModal = true;
    },
    finishDownload:function (){
      this.showModal = false;
    },


  }
}
</script>


<style lang="scss" scoped>


</style>
